import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeHalf: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVolumeHalf"><Path d="M15.8892 8.11133C16.8845 9.10663 17.5001 10.4816 17.5001 12.0004C17.5001 13.5192 16.8845 14.8942 15.8892 15.8895M1.5 7.5H6L12.5 3.75V20.25L6 16.5H1.5V7.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconVolumeHalf;
